import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const setPrimaryPill = async (payload) => {
    try {
        const url = `${BASE_URL}/citizen/primaryPill`;

        const accessToken = await getAccessToken();

        const response = await axios.put(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        toast.error(error);
        return error;
        // toast.error('Sorry unable to create your organization.');
    }
};

export const getPrimaryPill = async () => {
    try {
        const url = `${BASE_URL}/citizen/primaryPill`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

// Endpoint: GET /citizen/primaryPill

// Endpoint: PUT /citizen/primaryPill
